import Backbone from 'backbone';
import ko from 'knockout';

import ViewModel from './adgroupModel';
import template from './adgroup.pug';
import { setPosition } from './const';

export class AdGroupContextualAttributeView extends Backbone.View {
  initialize({
    deps,
    i18n,
    targetId,
  }) {
    this.deps = deps;
    this.i18n = i18n;
    this.adgroupId = targetId;
    this.viewModel = new ViewModel({
      i18n,
    });
  }


  render() {
    const {
      deps,
      adgroupId,
      i18n,
    } = this;

    deps.jsdata.AdGroup.findAll({
      limit: 1,
      select: ['Id', 'DeliveryStatus'],
      where: { Id: { $eq: adgroupId } },
    }).then((response) => {
      if (response.length && response.length > 0) {
        this.viewModel.updateAttribute({
          adgroupDeliveryStatus: response[0].DeliveryStatus,
        });
        this.$el.html(template({ i18n }));
        ko.applyBindings(this.viewModel, this.el);
        const container = this.$el.children('.contextual-tooltip-container');
        setPosition(container);
      }
    });
    return this;
  }
}
